module.exports = __webpack_public_path__ + "img/charlie_flower_thumb.1fdb60fa.jpg";